// Generated by portal/sdk/scripts/build.js.
module.exports = "/shows/milla-shows.36d0253d4e8d.js";
